import { render, staticRenderFns } from "./ListPayAuthority.vue?vue&type=template&id=1c4bd5e3&scoped=true&"
import script from "./ListPayAuthority.vue?vue&type=script&lang=ts&"
export * from "./ListPayAuthority.vue?vue&type=script&lang=ts&"
import style0 from "./ListPayAuthority.vue?vue&type=style&index=0&id=1c4bd5e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4bd5e3",
  null
  
)

export default component.exports